export default "__VITE_ASSET__f1b6e88f__"